export enum COUNTRY_VERSION_CREATION_OPTION {
  UPDATE_COUNTRY_VERSION_INFORMATION = 'updateCountryVersionInformation',
}
